import OrderSubmittedMap from './OrderSubmittedMap.component';

export default OrderSubmittedMap;
